module.exports = __webpack_public_path__ + "static/media/jetstream_logo.1566f727.png";